import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { first, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MyApplicationService } from '../my-application.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { ParentParameters, statusCode } from '../../../../app/auth/models/commonEnum';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/auth/service/common.service';

@Component({
	selector: 'app-completion-report',
	templateUrl: './completion-report.component.html',
	styleUrls: ['./completion-report.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CompletionReportComponent implements OnInit {
	public applicationDetail: any = [];
	public myFiles: any = [];
	public manPowerDetails: any;
	public ID: string;
	public completionForm: FormGroup;
	public documentForm: FormGroup;
	public dateofcommencement: FlatpickrOptions = {
		altInput: true
	};
	public dateofCompletions: FlatpickrOptions = {
		altInput: true
	}
	public actualDateOfCompletions: FlatpickrOptions = {
		altInput: true
	}
	private _unsubscribeAll: Subject<any>;
	public data: any;
	public researchPublicationForm: FormGroup;
	public equipmentStatusForm: FormGroup;
	public projectExpenditureForm: FormGroup;
	public form1_data: any = [];
	public principleInvestigator: string;
	public coPrincipleInvestigator: string;
	public category_imp_institution: string;
	public collaboratingOrg: string;
	public isDisabled = false;
	public submitted = false;
	public loading = false;
	public createdDate: string;
	public endDate: string;
	public sanctionDetails: any = [];
	public objectives: string;
	public contentHeader: object;
	public tempFiles = [];
	// public accountGrandTotal: Number;
	maxDate = this.calendar.getToday();
	minDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 10);

	endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
	projectExp: any;
	projectExpenditureArray: any;
	totalAmountSanctioned: number;
	totalActualExp: number;
	deviationTotal: number;
	expenditureTotal: number;
	expenditureTotalCost: any;
	deviationTotalCost: number;
	isFormInvalid: boolean;
	indexValue: any;

	constructor(private _formBuilder: FormBuilder,
		private calendar: NgbCalendar,
		private datePipe: DatePipe,
		private route: ActivatedRoute,
		private _commonService: CommonService,
		private _router: Router,
		private _myApplicationService: MyApplicationService,
		//private _CompletionReportService: CompletionReportService,
		private toastr: ToastrService) {
		this._unsubscribeAll = new Subject();

		this.completionForm = this._formBuilder.group({
			applyonlineId: [],
			principlInvestigator: [null],
			coInvestigator: [null],
			implementingIns: [null],
			collaboratingIns: [null],
			dateOfCommOfProject: [null],
			dateofcommencement: [null],
			dateofCompletions: [null, [Validators.required]],
			actualDateOfCompletions: [null],
			objeOfProject: [null],
			outputOfProject: [null, [Validators.required]],
			patentsTaken: [null, [Validators.required]],
			scientistsAndAssociated: [null, [Validators.required]],
			noOfPhd: [null, [Validators.required]],
			technicalpersonnel: [null, [Validators.required]],
			campsOrganized: [null, [Validators.required]],
			detailsOfWork: [null, [Validators.required]],
			suggestions: [null, [Validators.required]],
			equipmentAccount: [],
			equipmentDeviation: [null],
			equipmentExpenditure: [null],
			equipmentTotalCost: [null],
			consumableAccount: [null],
			consumableExpenditure: [null],
			consumableDeviation: [null],
			consumableTotalCost: [null],
			manpowerAccount: [null],
			manpowerExpenditure: [null],
			manpowerDeviation: [null],
			manpowerTotalCost: [null],
			travelAccount: [null],
			travelExpenditure: [null],
			travelDeviation: [null],
			travelTotalCost: [null],
			contAccount: [null],
			contExpenditure: [null],
			contDeviation: [null],
			contTotalCost: [null],
			otherAccount: [null],
			otherExpenditure: [null],
			otherDeviation: [null],
			otherTotalCost: [null],
			expensesAccount: [null],
			expensesExpenditure: [null],
			expensesDeviation: [null],
			expensesTotalCost: [null],
			totalAccount: [null],
			totalExpenditure: [null],
			totalDeviation: [null],
			totalTotalCost: [null],
			accountsGrandTotal: [0.00],
			expendituresGrandTotal: [0.00],
			deviationsGrandTotal: [0.00],
			totalCostGrandTotal: [0.00]
		});

		this.researchPublicationForm = new FormGroup({
			publicationArray: this._formBuilder.array([
				this._formBuilder.group({
					authors: [null, [Validators.required]],
					titlepapers: [null, [Validators.required]],
					nameOfJournal: [null, [Validators.required]],
					volume: [null, [Validators.required]],
					pages: [null, [Validators.required]],
					year: [null, [Validators.required]]
				})
			])
		});
		this.documentForm = new FormGroup({
			documentArray: this._formBuilder.array([
				this._formBuilder.group({
					uploadDocument: [, [Validators.required]],
					documentRemark: [null, [Validators.required]],
					documentName: [],
					documentFileName: ["Select File"],
				})
			])
		});
		this.equipmentStatusForm = new FormGroup({
			EquipmentStatusArray: this._formBuilder.array([
				this._formBuilder.group({
					nameOfEquipment: [null, [Validators.required]],
					yearOfPurchase: [null, [Validators.required]],
					makeModel: [null, [Validators.required]],
					costOfInstallation: [null, [Validators.required]],
					dateOfInstallation: [null, [Validators.required]],
					rate: [null, [Validators.required]],
					remarks: [null, [Validators.required]],
					installationDate: [],
				})
			])
		});
		this.equipmentStatusForm = new FormGroup({
			EquipmentStatusArray: this._formBuilder.array([
				this._formBuilder.group({
					nameOfEquipment: [null, [Validators.required]],
					yearOfPurchase: [null, [Validators.required]],
					makeModel: [null, [Validators.required]],
					costOfInstallation: [null, [Validators.required]],
					dateOfInstallation: [null, [Validators.required]],
					rate: [null, [Validators.required]],
					remarks: [null, [Validators.required]],
					installationDate: [],
				})
			])
		});

		this.projectExpenditureForm = this._formBuilder.group({
			projectExpenditureArray: this._formBuilder.array([
				
			]),
		});

		this.route.params.subscribe(parmas => {
			this.ID = parmas["id"];
		});
	}

	ngOnInit(): void {
		// this._CompletionReportService.onSettingsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
		// 	this.data = response;
		// });
		this.manPowerpatch(this.ID);
		this.contentHeader = {
			headerTitle: 'Completion Report',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'My Application',
						isLink: true,
						link: '/'
					},
					{
						name: 'Completion Report',
						isLink: false
					},
				]
			}
		};
		this.getProjectExpenditureArray();
	}
	addRow() {
		const publicationArray = <FormArray>this.researchPublicationForm.controls['publicationArray'];
		if (this.researchPublicationForm.status != "INVALID") {
			publicationArray.push(this.initFundRow());
			this.toastr.success('New row added sucessfully.', 'Success!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
			return true;
		} else {
			this.toastr.info('please fillup the current row details.', 'Info!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
		}
		return false;
	}
	initFundRow(): FormGroup {
		return this._formBuilder.group({
			authors: [null, [Validators.required]],
			titlepapers: [null, [Validators.required]],
			nameOfJournal: [null, [Validators.required]],
			volume: [null, [Validators.required]],
			pages: [null, [Validators.required]],
			year: [null, [Validators.required]]

		});
	}
	addfileRow() {
		const documentFormArray = <FormArray>this.documentForm.controls['documentArray'];
		if (this.documentForm.status != "INVALID") {
			documentFormArray.push(this.initCostRow());
			this.toastr.success('New row added sucessfully.', 'Success!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
			return true;
		}
		else {
			this.toastr.info('please fillup the current row details.', 'Info!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
		}
		return false;
	}
	initCostRow(): FormGroup {
		return this._formBuilder.group({
			uploadDocument: [null, [Validators.required]],
			documentRemark: [null, [Validators.required]],
			documentName: [null],
			documentFileName: ["Select file"]
		});
	}
	browsbuttonClick(type, index) {
		if (type === "document") {
			this.documentForm.controls.documentArray["controls"][index].controls.documentFileName.setValue("Select file");
		}
	}
	/**
	 * function get uploaded file on upload file change.
	 ***/
	uploadFileChange(event: any, name: string, index: number, fileSize: any) {
		for (var i = 0; i < event.target.files.length; i++) {
			var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}

			this.tempFiles = [];
			var key = name + "[" + index + "]";
			this.myFiles.push({ key: key, file: event.target.files[i] });
			this.tempFiles.push({ key: key, file: event.target.files[i] });
			if (name === 'document') {
				this.documentForm.controls.documentArray["controls"][index].controls.documentFileName.setValue(this.showFiles(this.tempFiles));
			}
		}
	}
	/**
	 * function return selected file name.
	 ***/
	showFiles(documentsList: any) {
		let files = '';
		for (let i = 0; i < documentsList.length; i++) {
			files += documentsList[i].file.name;
			if (!(documentsList.length - 1 === i)) {
				files += ',';
			}
		}
		return files;
	}
	/** Function for remove row**/
	deleteRow(index) {
		let newthis = this;
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be remove this row!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger ml-1'
			}
		}).then(function (result) {
			if (result.value) {
				const documentArray = <FormArray>newthis.documentForm.controls['documentArray'];
				if (documentArray.length == 1) {
					newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return false;
				} else {
					documentArray.removeAt(index);
					newthis.toastr.info("Row deleted successfully.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return true;
				}
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				Swal.fire({
					title: 'Cancelled',
					text: 'Your imaginary file is safe :)',
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
			}
		});
	}
	deletePublicationFormRow(index) {
		let newthis = this;
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be remove this row!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger ml-1'
			}
		}).then(function (result) {
			if (result.value) {
				const publicationArray = <FormArray>newthis.researchPublicationForm.controls['publicationArray'];
				if (publicationArray.length == 1) {
					newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return false;
				} else {
					publicationArray.removeAt(index);
					newthis.toastr.info("Row deleted successfully.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return true;
				}
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				Swal.fire({
					title: 'Cancelled',
					text: 'Your imaginary file is safe :)',
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
			}
		});
	}
	deleteEquipmentFormRow(index) {
		let newthis = this;
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be remove this row!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger ml-1'
			}
		}).then(function (result) {
			if (result.value) {
				const EquipmentStatusArray = <FormArray>newthis.equipmentStatusForm.controls['EquipmentStatusArray'];
				if (EquipmentStatusArray.length == 1) {
					newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return false;
				} else {
					EquipmentStatusArray.removeAt(index);
					newthis.toastr.info("Row deleted successfully.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return true;
				}
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				Swal.fire({
					title: 'Cancelled',
					text: 'Your imaginary file is safe :)',
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
			}
		});
	}
	addEquimentRow() {
		const equipmentFormArray = <FormArray>this.equipmentStatusForm.controls['EquipmentStatusArray'];
		if (this.equipmentStatusForm.status != "INVALID") {
			equipmentFormArray.push(this.initEquimentRow());
			this.toastr.success('New row added sucessfully.', 'Success!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
			return true;
		}
		else {
			this.toastr.info('please fillup the current row details.', 'Info!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
		}
		return false;
	}
	initEquimentRow(): FormGroup {
		return this._formBuilder.group({
			nameOfEquipment: [null, [Validators.required]],
			yearOfPurchase: [null, [Validators.required]],
			makeModel: [null, [Validators.required]],
			costOfInstallation: [null, [Validators.required]],
			dateOfInstallation: [null, [Validators.required]],
			rate: [null, [Validators.required]],
			remarks: [null, [Validators.required]]
		});
	}
	manPowerpatch(id) {
		const data = {
			applyonlineId: id
		}
		this._myApplicationService.getManpowerForCompletionReport(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.manPowerDetails = result["data"]["response"]["manPowerDetails"];
			}
		})
		this._myApplicationService.getApplicationDetail(data).subscribe((result: any) => {
			this.applicationDetail = null;
			if (result.statusCode == statusCode.SUCCESS) {
				this.applicationDetail = result["data"]["response"];
				this.form1_data = this.applicationDetail.form1_data;
				this.principleInvestigator = this.form1_data.principleInvestigator;
				if (this.form1_data.coPrincipalInvestigator != "") {
					this.coPrincipleInvestigator = this.form1_data.coPrincipalInvestigator;
				} else {
					this.coPrincipleInvestigator = "";
				}
				this.objectives = this.form1_data.objectives;
				this.category_imp_institution = this.form1_data.category_imp_institution;
				this.collaboratingOrg = this.form1_data.collaboratingOrg;
			}
		});
		this._myApplicationService.getSanctionDetials(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.sanctionDetails = result["data"]["response"];
				this.createdDate = this.sanctionDetails.createdDate;
				this.endDate = this.sanctionDetails.endDate;
			}
		})
	}
	saveCompletionReportData() {
		const self = this;
		this.isDisabled = true;
		this.submitted = true;
		if (this.completionForm.invalid  || this.isFormInvalid) {
			this.isDisabled = false;
			return false;
		}
		const data = self.prepareSave();
		this.loading = true;
		this._myApplicationService
			.submitCompletionReportData(data).pipe(first())
			.subscribe(
				response => {
					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.isDisabled = false;
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'Completion Report Save successfully.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						this._router.navigate(['/my-application']);
					}
					else {
						// this.error = response["message"];
						this.isDisabled = false;
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
				error => {
					//this.error = error;
					// this.isDisabled = false;
					// this.loading = false;
					// Swal.fire({
					// 	icon: 'error',
					// 	title: 'Error!',
					// 	text: error,
					// 	customClass: {
					// 		confirmButton: 'btn btn-error'
					// 	}
					// });
				}
			);

		return false;
	}
	prepareSave() {
		let input: FormData = new FormData();
		var researchPublicationArray = this.researchPublicationForm.value.publicationArray;
		var equipmentStatusArray = this.equipmentStatusForm.value.EquipmentStatusArray;
		var projectExpenditureArray = this.projectExpenditureForm.value.projectExpenditureArray;
		console.log(projectExpenditureArray);
		var documentArray = this.documentForm.value.documentArray;
		let index = 0;
		
		equipmentStatusArray.forEach(element => {
			let installDate = element.dateOfInstallation;
			if(installDate != null){
				let insDate = installDate.year + '-' + installDate.month + '-' + installDate.day;
				element.installationDate = insDate;
			}
		}); index++;

		input.append('projectExpenditureArray', projectExpenditureArray.length > 0 ? JSON.stringify(projectExpenditureArray) : "");
		input.append('equipmentStatusArray', equipmentStatusArray.length > 0 ? JSON.stringify(equipmentStatusArray) : "");
		input.append('researchPublicationArray', researchPublicationArray.length > 0 ? JSON.stringify(researchPublicationArray) : "");
		input.append('documentDetailsArray', documentArray.length > 0 ? JSON.stringify(documentArray) : "");

		input.append('applyonlineId', this.ID);
		input.append('actualDateOfCompletion', this.completionForm.controls.actualDateOfCompletions.value);
		input.append('awarenessTrainingCampsOrganized', this.completionForm.controls.campsOrganized.value);

		input.append('consumableAccount', this.completionForm.controls.consumableAccount.value);
		input.append('consumableDeviation', this.completionForm.controls.consumableDeviation.value);
		input.append('consumableExpenditure', this.completionForm.controls.consumableExpenditure.value);
		input.append('consumableTotalCost', this.completionForm.controls.consumableTotalCost.value);
		input.append('contAccount', this.completionForm.controls.contAccount.value);
		input.append('contDeviation', this.completionForm.controls.contDeviation.value);
		input.append('contExpenditure', this.completionForm.controls.contExpenditure.value);
		input.append('contTotalCost', this.completionForm.controls.contTotalCost.value);

		// input.append('dateOfCommOfProject', this.completionForm.controls.dateOfCommOfProject.value);
		let approvedData = this.completionForm.controls.dateofCompletions.value;
		let approvedDateCompletion = approvedData.year + '-' + approvedData.month + '-' + approvedData.day;
		input.append('approveDateofCompletions', this.datePipe.transform(approvedDateCompletion, "yyyy-MM-dd"));
		// input.append('dateofcommencement', this.completionForm.controls.dateofcommencement.value);
		input.append('detailsOfWork', this.completionForm.controls.detailsOfWork.value);

		input.append('equipmentAccount', this.completionForm.controls.equipmentAccount.value);
		input.append('equipmentDeviation', this.completionForm.controls.equipmentDeviation.value);
		input.append('equipmentExpenditure', this.completionForm.controls.equipmentExpenditure.value);
		input.append('equipmentTotalCost', this.completionForm.controls.equipmentTotalCost.value);

		input.append('expensesAccount', this.completionForm.controls.expensesAccount.value);
		input.append('expensesDeviation', this.completionForm.controls.expensesDeviation.value);
		input.append('expensesExpenditure', this.completionForm.controls.expensesExpenditure.value);
		input.append('expensesTotalCost', this.completionForm.controls.expensesTotalCost.value);

		input.append('implementingIns', this.completionForm.controls.implementingIns.value);

		input.append('manpowerAccount', this.completionForm.controls.manpowerAccount.value);
		input.append('manpowerDeviation', this.completionForm.controls.manpowerDeviation.value);
		input.append('manpowerExpenditure', this.completionForm.controls.manpowerExpenditure.value);
		input.append('manpowerTotalCost', this.completionForm.controls.manpowerTotalCost.value);

		input.append('noOfPhd', this.completionForm.controls.noOfPhd.value);
		input.append('objeOfProject', this.completionForm.controls.objeOfProject.value);

		input.append('otherAccount', this.completionForm.controls.otherAccount.value);
		input.append('otherDeviation', this.completionForm.controls.otherDeviation.value);
		input.append('otherExpenditure', this.completionForm.controls.otherExpenditure.value);
		input.append('otherTotalCost', this.completionForm.controls.otherTotalCost.value);

		input.append('outputOfProject', this.completionForm.controls.outputOfProject.value);
		input.append('patentsTaken', this.completionForm.controls.patentsTaken.value);
		input.append('scientistsAndAssociated', this.completionForm.controls.scientistsAndAssociated.value);
		input.append('suggestions', this.completionForm.controls.suggestions.value);
		input.append('technicalpersonnel', this.completionForm.controls.technicalpersonnel.value);

		input.append('totalAccount', this.completionForm.controls.totalAccount.value);
		input.append('totalDeviation', this.completionForm.controls.totalDeviation.value);
		input.append('totalExpenditure', this.completionForm.controls.totalExpenditure.value);
		input.append('totalTotalCost', this.completionForm.controls.totalTotalCost.value);
		input.append('travelAccount', this.completionForm.controls.travelAccount.value);
		input.append('travelDeviation', this.completionForm.controls.travelDeviation.value);
		input.append('travelExpenditure', this.completionForm.controls.travelExpenditure.value);
		input.append('travelTotalCost', this.completionForm.controls.travelTotalCost.value);

		for (var i = 0; i < this.myFiles.length; i++) {
			input.append(this.myFiles[i].key, this.myFiles[i].file);
		}
		return input;
	}
	/**
	 * Get FormData
	 */
	get formDetails() {
		return this.completionForm.controls;
	}
	/**
	 * function for get formate6 data.
	 ***/
	get documentDetails() {
		return this.documentForm.controls;
	}
	onChangeFieldTotal(index) {
		const expenditureValues 	= this.projectExpenditureForm.controls.projectExpenditureArray.value;
		this.totalAmountSanctioned 	= 0;
		this.totalActualExp 		= 0;
		this.deviationTotalCost		= 0;
		this.expenditureTotalCost 	= 0;
		expenditureValues.forEach(element => {
			const amountSanctioned 		=  (isNaN(parseFloat(element.amountSanctioned.replaceAll(",",""))) ? 0 : parseFloat(element.amountSanctioned.replaceAll(",","")));
			this.totalAmountSanctioned 	= this.totalAmountSanctioned + amountSanctioned;
			const actualExpenditure	 	=  (isNaN(parseFloat(element.actualExpenditure.replaceAll(",",""))) ? 0 : parseFloat(element.actualExpenditure.replaceAll(",","")));
			this.totalActualExp 		= this.totalActualExp + actualExpenditure;
			const deviationTotal 		=  (isNaN(parseFloat(element.deviation.replaceAll(",",""))) ? 0 : parseFloat(element.deviation.replaceAll(",","")));
			this.deviationTotalCost 	= this.deviationTotalCost + deviationTotal;
			const expenditureTotal 		=  (isNaN(parseFloat(element.expenditureTotalCost.replaceAll(",",""))) ? 0 : parseFloat(element.expenditureTotalCost.replaceAll(",","")));
			this.expenditureTotalCost 	= this.expenditureTotalCost + expenditureTotal;
			

		});
		this.completionForm.controls.accountsGrandTotal.setValue(this.numFormat(this.totalAmountSanctioned.toFixed(2)));
		this.completionForm.controls.expendituresGrandTotal.setValue(this.numFormat(this.totalActualExp.toFixed(2)));
		this.completionForm.controls.deviationsGrandTotal.setValue(this.numFormat(this.deviationTotalCost.toFixed(2)));
		this.completionForm.controls.totalCostGrandTotal.setValue(this.numFormat(this.expenditureTotalCost.toFixed(2)));
		if(this.expenditureTotalCost > 100 ){
			this.indexValue = index;
			this.isFormInvalid = true;
			return false;
		}else{
			this.isFormInvalid = false;
			return true;
		}
		
	}
	getProjectExpenditure (): FormArray {
		return this.projectExpenditureForm.get('projectExpenditureArray') as FormArray
	}
	numFormat(number){
        var outputformat = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2,minimumFractionDigits: 2 }).format(number);
        return outputformat;
    }
	getProjectExpenditureArray(){
		this._commonService.getParameterSettings(ParentParameters.PROPOSED_COST_ITEM).subscribe((result: any) => {
			this.projectExpenditureArray = result["data"]["response"];
			if (this.projectExpenditureArray.length > 0 && result.statusCode == 200) {
				this.projectExpenditureArray.forEach(element => {
					const projectExpenditureArray = <FormArray>this.projectExpenditureForm.controls['projectExpenditureArray'];
					projectExpenditureArray.push(this.initProjectExpenditureCostRow(element.paraDescription, element.paraId, element, true));
				});
			}
		});
	}
	initProjectExpenditureCostRow(name: string, id: number, element, isEdit){
		let form = this._formBuilder.group({
			proposedCostItemName: [name],
			proposedCostItemID: [id],
			amountSanctioned:[,[Validators.required]],
			actualExpenditure:[,[Validators.required]],
			deviation:[,[Validators.required]],
			expenditureTotalCost:[,[Validators.required]]
		});
		return form
	}
}
